import React from "react";
import "./index.css";

export default function ErrorMsg({ msg, customStyles }) {
  return (
    <div className={`error-msg ${customStyles}`}>
      <div className="error-msg__icon ">!</div>
      <p className="error-msg__text">{msg}</p>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/AdminRegistration/components/ErrorMsg/index.js